import { configureStore } from "@reduxjs/toolkit";
import adminReducers from "./reducers/adminReducers";
export const store = configureStore({
  reducer: {
    admin: adminReducers,
  },
});
